import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import i18next from "i18next";

class SubEducation extends Component {
    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (<>
                <div className="row mb-2">
                    <div className="col-md-4">
                        {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.listSubForPO}/>
                    </div>
                </div>
            </>);
    };

    render() {
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubEducation_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-filter'/> {i18next.t("Filters")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ComplexParam dataItem={this.props.listSubForPOParams}
                                  readOnly={false}
                                  showSearchBar={false}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  parentDataItem={this.props.listSubForPO}
                                  renderParams={this.renderParam}
                    />
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={i18next.t("SubEducation_GridTitle", {people_count: ''})}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <GridView dataItem={this.props.listSubForPO}/>
                </PlaceholderWrapper>
            </>);
    }
}

SubEducation.propTypes = {
    dispatch: PropTypes.func.isRequired, listSubForPO: PropTypes.object, listSubForPOParams: PropTypes.object
}

SubEducation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.subEducationState.EmployeesEducation_ListSubForPO,
        listSubForPOParams: state.subEducationState.EmployeesEducation_ListSubForPOParams
    }
}

export default connect(mapStateToProps)(SubEducation);